import {
  KPI_COLORS as KPI_COLORS_COMMON,
  stateColorOption,
  statusColorOption
} from '@fareye/configs'
export const RoutesPath = {
  HOME: '/',
  INTRANSIT: '/in-transit',
  INTRANSIT_MAP: '/in-transit/map',
  INTRANSIT_TRANSPORTERS: '/in-transit/transporters',
  INTRANSIT_TRIPS: '/in-transit/trips',
  INTRANSIT_ETA: '/in-transit/eta',
  SHARE_TRIP_INTRANSIT: '/share/in-transit/trips',
  SHARE_TRIP_INPLANT: '/share/in-plant/trips',

  TRIP_DETAILS: '/trip-details',
  POI: '/poi',
  ADD_POI: '/poi/add',
  INPLANT: '/in-plant',
  INPLANT_MAP: '/in-plant/map',
  INPLANT_TRIPS: '/in-plant/trips',
  INDENT: '/indent',
  INDENT_VEHICLE: '/indent/vehicle',
  LOGIN: '/login',
  LOGOUT: '/logout',
  KPI: '/kpi',
  NEARBY: '/nearby',
  SETTINGS: '/settings',
  ALERT_SETTINGS: '/settings/alerts',
  KPI_EDITOR: '/kpi/editor',
  ALLOCATION: '/allocation',
  REPORT: '/report',
  PROFILE: '/profile'
}

export const RoutesLabel = {
  KPI: 'KPI',
  KPI_PLAYGROUND: 'KPI Playground',
  INPLANT: 'In Plant',
  INPLANT_PERF: 'In Plant Performance',
  INPLANT_MAP: 'In Plant Map',
  INTRANSIT: 'InTransit',
  INTRANSIT_PERF: 'InTransit Performance',
  INTRANSIT_TRANSPORTERS: 'Transporters',
  INTRANSIT_ETA: 'E. T. A',
  INTRANSIT_MAP: 'InTransit Map',
  INTRANSIT_TRIPS: 'InTransit Trips',
  INDENT: 'Indent',
  INDENT_LIST: 'Indent List',
  INDENT_VEHICLE: 'Vehicle List',
  TRIP_DETAILS: 'Trip Details',
  POI: 'Poi',
  ETA: 'Eta',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  NEARBY: 'Nearby',
  ALLOCATION: 'Allocation',
  ALLOCATION_LIST: 'Allocation List',
  ALERTS: 'Alerts',
  ALERT_SETTINGS: 'Alerts',
  Report: 'report'
}
export const KPI_COLORS = {
  ...KPI_COLORS_COMMON,
  ...stateColorOption,
  ...statusColorOption
}
//Ontime,Early,Delayed,delayed,Unknown,untracked,untracked_state,
//untracked_status,on_time,OnTime,On_time, in_transit,at_loading
export const AUTHORIZATION_HEADER = 'Authorization'
export const SESSION_HEADER = 'session_token'
export const AUTH_TOKEN = '@Fareye:AuthToken'
export const HEADER_INFLECTION = {
  headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
}
export const IN_PLANT = 'inplant'

export const JIRA_URL =
  'https://fareye.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-lxsann/b/23/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=b1f1ba67'

export const ENVIRONMENT = 'environment'

export const GRAPH_DATA_MAPPING = {
  condition: {
    value: 'value',

    label: 'label'
  },
  dataSource: {
    label: 'label',

    value: 'value'
  },
  dimension: {
    value: 'value',

    label: 'label'
  },
  filterType: {
    value: 'value',

    label: 'label'
  },
  filterKey: {
    value: 'value',

    label: 'label'
  },
  filterValue: {
    label: 'label',

    value: 'value'
  },
  metricKey: {
    value: 'value',

    label: 'label'
  },
  metricType: {
    value: 'value',

    label: 'label'
  },
  sortKey: {
    value: 'value',

    label: 'label'
  },
  sortType: {
    value: 'value',

    label: 'label'
  },
  pageIdList: {
    value: 'key',

    label: 'value'
  },
  unit: {
    value: 'key',

    label: 'value'
  }
}
export const KPI_CONFIG = [
  {
    id: 306,
    user_id: null,
    name: 'Loading Performance',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'Loading Performance',
        chartDescription: 'Showing Loading performance for Plants',
        chartType: 'line',
        dimensionDescription: 'Loading TAT',
        metricDescription: 'Date',
        dimensions: [
          {
            dimension: {
              label: 'Day',
              value: 'day'
            },
            breakdownDimension: {
              label: 'Origin',
              value: 'origin'
            },
            dimensionUnit: {
              key: 'date',
              value: 'date'
            },
            isDrillDown: true
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Loading Performance',
              value: 'loading_tat'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'minute',
              value: 'minute'
            }
          }
        ],
        sortKey: {
          label: 'Loading Performance',
          value: 'loading_tat'
        },
        sortType: {
          label: 'Ascending',
          value: 'asc'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: [[]],
          name: '',
          dataSource: null
        },
        pageIdList: null,
        hideSort: true
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 1
    },
    deleted_at: null,
    created_at: '2020-02-12T08:08:46.000Z',
    updated_at: '2020-05-05T16:33:39.000Z',
    sub_type: 'kpi',
    page_id: null
  },
  {
    id: 307,
    user_id: null,
    name: 'UnLoading Performance',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'UnLoading Performance',
        chartDescription: 'Showing UnLoading performance for Destination',
        chartType: 'line',
        dimensionDescription: 'Unloading TAT',
        metricDescription: 'Date',
        dimensions: [
          {
            dimension: {
              label: 'Day',
              value: 'day'
            },
            breakdownDimension: {
              label: 'Destination',
              value: 'destination'
            },
            dimensionUnit: {
              key: 'date',
              value: 'date'
            },
            isDrillDown: true
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Loading Performance',
              value: 'unloading_tat'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'minute',
              value: 'minute'
            }
          }
        ],
        sortKey: {
          label: 'Loading Performance',
          value: 'unloading_tat'
        },
        sortType: {
          label: 'Ascending',
          value: 'asc'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: [[]],
          name: '',
          dataSource: null
        },
        pageIdList: null,
        hideSort: true
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 2
    },
    deleted_at: null,
    created_at: '2020-02-12T08:27:31.000Z',
    updated_at: '2020-05-05T16:35:57.000Z',
    sub_type: 'kpi',
    page_id: null
  },
  {
    id: 313,
    user_id: null,
    name: 'Trip State',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'Trip State ( At Primary loading , Enroute , etc) ',
        chartDescription: 'Showing status distribution for trips',
        chartType: 'pie',
        dimensionDescription: 'Vehicle Count ',
        metricDescription: 'State',
        dimensions: [
          {
            dimension: {
              label: 'State',
              value: 'state'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'Transporter',
                  value: 'transporter'
                },
                chartType: 'bar',
                metricDescription: 'Transporter'
              }
            ],
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            isDrillDown: true
          },
          {
            dimension: {
              label: 'Route',
              value: 'route'
            },
            breakdownDimension: {
              label: 'State',
              value: 'state'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'Transporter',
                  value: 'transporter'
                },
                breakdownDimension: {
                  label: 'State',
                  value: 'state'
                },
                chartType: 'bar',
                metricDescription: 'Transporter'
              }
            ],
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            isDrillDown: true,
            chartType: 'bar',
            metricDescription: 'Route'
          },
          {
            dimension: {
              label: 'Material',
              value: 'material'
            },
            breakdownDimension: {
              label: 'State',
              value: 'state'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'Transporter',
                  value: 'transporter'
                },
                breakdownDimension: {
                  label: 'State',
                  value: 'state'
                },
                chartType: 'bar',
                metricDescription: 'Transporter'
              }
            ],
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            isDrillDown: true,
            chartType: 'bar',
            metricDescription: 'Material'
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Transit Performance',
              value: 'value_count'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'number',
              value: 'number'
            }
          }
        ],
        sortKey: {
          label: 'Value Count',
          value: 'value_count'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: null,
          name: '',
          dataSource: null
        },
        pageIdList: null
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 3
    },
    deleted_at: null,
    created_at: '2020-02-12T08:33:22.000Z',
    updated_at: '2020-05-28T12:09:42.000Z',
    sub_type: 'kpi',
    page_id: null
  },
  {
    id: 310,
    user_id: null,
    name: 'Vendor Performance',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'Vendor Performance',
        chartDescription: 'Showing Trip Status across transporters',
        chartType: 'bar',
        layout: 'horizontal',
        dimensionDescription: 'Vehicle Count ',
        metricDescription: 'Transporters ',
        dimensions: [
          {
            dimension: {
              label: 'Transporter',
              value: 'transporter'
            },
            breakdownDimension: {
              label: 'Status',
              value: 'status'
            },
            drillDownDimensions: null,
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            isDrillDown: true
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Transit Performance',
              value: 'value_count'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'number',
              value: 'number'
            }
          }
        ],
        sortKey: {
          label: 'Loading Performance',
          value: 'value_count'
        },
        sortType: {
          label: 'Descending',
          value: 'desc'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: [[]],
          name: '',
          dataSource: null
        },
        pageIdList: null
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 4
    },
    deleted_at: null,
    created_at: '2020-02-12T08:30:33.000Z',
    updated_at: '2020-05-28T12:01:14.000Z',
    sub_type: 'kpi',
    page_id: null
  },
  {
    id: 314,
    user_id: null,
    name: 'Transit Performance',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'Transit Performance',
        chartDescription: 'Showing Transit performance for Consigners Trip',
        chartType: 'pie',
        dimensionDescription: 'Status Count ',
        metricDescription: 'Routes',
        dimensions: [
          {
            dimension: {
              label: 'Status',
              value: 'status'
            },
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'Transporter',
                  value: 'transporter'
                },
                breakdownDimension: {
                  label: 'Status',
                  value: 'status'
                },
                metricDescription: 'Transporter',
                chartType: 'bar',
                isDrillDown: true
              }
            ],
            isDrillDown: true
          },
          {
            dimension: {
              label: 'Transporter',
              value: 'transporter'
            },
            breakdownDimension: {
              label: 'Status',
              value: 'status'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'Material',
                  value: 'material'
                },
                breakdownDimension: {
                  label: 'Status',
                  value: 'status'
                },
                metricDescription: 'Material',
                chartType: 'bar',
                isDrillDown: true
              }
            ],
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            chartType: 'bar',
            metricDescription: 'Transporter',
            isDrillDown: true
          },
          {
            dimension: {
              label: 'Material',
              value: 'material'
            },
            breakdownDimension: {
              label: 'Status',
              value: 'status'
            },
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            chartType: 'bar',
            metricDescription: 'Materials'
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Transit Performance',
              value: 'value_count'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'number',
              value: 'number'
            }
          }
        ],
        sortKey: {
          label: 'Values',
          value: 'value_count'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: [[]],
          name: '',
          dataSource: null
        },
        pageIdList: null
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 5
    },
    deleted_at: null,
    created_at: '2020-02-12T08:34:16.000Z',
    updated_at: '2020-05-28T12:05:24.000Z',
    sub_type: 'kpi',
    page_id: null
  },
  {
    id: 311,
    user_id: null,
    name: 'Route Performance',
    data: {
      graphConfig: {
        dataSource: {
          label: 'Consigner Data',
          value: 'ConsignerTrip'
        },
        chartTitle: 'Route Performance',
        chartDescription: 'Showing Trip Status across Routes',
        chartType: 'bar',
        layout: 'horizontal',
        dimensionDescription: 'Vehicle Count ',
        metricDescription: 'Route ',
        dimensions: [
          {
            dimension: {
              label: 'Route',
              value: 'route'
            },
            breakdownDimension: {
              label: 'Status',
              value: 'status'
            },
            drillDownDimensions: [
              {
                drillDownDimension: {
                  label: 'transporter',
                  value: 'transporter'
                },
                metricDescription: 'Transporters',
                breakdownDimension: {
                  label: 'Status',
                  value: 'status'
                },
                chartType: 'bar',
                isDrillDown: true
              }
            ],
            dimensionUnit: {
              key: 'string',
              value: 'string'
            },
            isDrillDown: true
          }
        ],
        metricList: [
          {
            aggKey: {
              label: 'Transit Performance',
              value: 'value_count'
            },
            aggType: {
              value: 'avg',
              label: 'Count'
            },
            metricUnit: {
              key: 'number',
              value: 'number'
            }
          }
        ],
        sortKey: {
          label: 'Loading Performance',
          value: 'value_count'
        },
        sortType: {
          label: 'Descending',
          value: 'desc'
        },
        maxNoOfBars: 30,
        compactNo: false,
        decimalPrecision: '',
        filter: {
          filterData: [[]],
          name: '',
          dataSource: null
        },
        pageIdList: null
      },
      style: {
        graphScreenRatio: 1.7777777777777777
      },
      order: 6
    },
    deleted_at: null,
    created_at: '2020-02-12T08:31:50.000Z',
    updated_at: '2020-05-28T11:52:31.000Z',
    sub_type: 'kpi',
    page_id: null
  }
]

export const SkipPostURL = [
  '/api/v1/es/kpi_aggs',
  '/api/v1/es/kpi_results',
  '/api/v1/consigner/add_route_mapping',
  '/auth/users/sign_in',
  '/api/v3/journeys/list',
  '/api/v3/journeys/route_performance',
  '/api/v3/journeys/transporter_performance',
  '/api/v3/journeys/in_transit_map',
  '/api/v3/reports/journey',
  '/api/v3/journeys/route_performance_details',
  '/api/v3/journeys/transporter_performance_details'
]

export const SHIPMENT_TYPES = [
  { label: 'Shipment', value: 'Journey', dataSource: 'Journey' },
  { label: 'Package', value: 'Shipment', dataSource: 'Shipment' }
  // { label: 'Item', value: 'item', dataSource: 'Item' }
]

export const DailyDispatch = {
  id: 309,
  user_id: null,
  name: 'Daily Dispatch',
  data: {
    graphConfig: {
      dataSource: {
        label: 'Shipment',
        value: 'Shipment'
      },
      chartTitle: 'Daily Dispatch',
      chartDescription: 'Showing day wise dispatch across plants',
      chartType: 'line',
      dimensionDescription: 'Vehicle Count ',
      metricDescription: 'Date ',
      dimensions: [
        {
          dimension: {
            label: 'Day-Plant Wise',
            value: 'day'
          },
          breakdownDimension: {
            label: 'Plant',
            value: 'pol_name'
          },
          dimensionUnit: {
            key: 'date',
            value: 'date'
          }
        },
        {
          dimension: {
            label: 'Plant Month Wise',
            value: 'month'
          },
          breakdownDimension: {
            label: 'Plant',
            value: 'pol_name'
          },
          dimensionUnit: {
            key: 'date',
            value: 'date'
          }
        },
        {
          dimension: {
            label: 'Top Destination',
            value: 'pod_name'
          },
          chartType: 'bar',
          metricDescription: 'Destination',
          dimensionUnit: {
            key: 'string',
            value: 'string'
          }
        },
        {
          dimension: {
            label: 'Material',
            value: 'material'
          },
          chartType: 'bar',
          metricDescription: 'Material',
          dimensionUnit: {
            key: 'number',
            value: 'number'
          }
        }
      ],
      metricList: [
        {
          aggKey: {
            label: 'Transit Performance',
            value: 'value_count'
          },
          aggType: {
            value: 'avg',
            label: 'Count'
          },
          metricUnit: {
            key: 'number',
            value: 'number'
          }
        }
      ],
      sortKey: {
        label: 'Loading Performance',
        value: 'value_count'
      },
      maxNoOfBars: 30,
      compactNo: false,
      decimalPrecision: '',
      filter: {
        filterData: [[]],
        name: '',
        dataSource: null
      },
      pageIdList: null,
      hideSort: true
    },
    style: {
      graphScreenRatio: 3
    },
    order: 7
  },
  deleted_at: null,
  created_at: '2020-02-12T08:29:49.000Z',
  updated_at: '2020-07-14T18:10:18.000Z',
  sub_type: 'kpi',
  page_id: null
}

export const ScoreCardConfig = {
  shipping: {
    graphConfig: {
      dataSource: {
        label: 'Shipment',
        value: 'Shipment'
      },
      chartTitle: 'On Time Shipping',
      chartDescription: 'Showing Transporter Status distribution',
      chartType: 'scorecard',
      layout: 'horizontal',
      dimensionDescription: 'Status Count ',
      metricDescription: 'Transporter',
      hideDimension: true,
      benchmarkDimension: {},
      metric: {
        aggKey: {
          label: 'Transit Performance',
          value: 'shipping_tat'
        },
        aggType: {
          value: 'range',
          label: 'Range'
        },
        metricUnit: {
          key: 'number',
          value: 'number'
        },
        value: [
          {
            key: 'Early',
            to: -1
          },
          {
            key: 'Ontime',
            from: 0,
            to: 1
          },
          {
            key: 'Delay',
            from: 2
          }
        ]
      },
      sortKey: {
        label: 'Values',
        value: 'value_count'
      },
      maxNoOfBars: 30,
      compactNo: false,
      decimalPrecision: '',
      filter: [],
      pageIdList: null
    },
    style: {
      graphScreenRatio: 1.7777777777777777
    },
    order: 5
  },
  delivery: {
    graphConfig: {
      dataSource: {
        label: 'Shipment',
        value: 'Shipment'
      },
      chartTitle: 'On Time Delivery',
      chartDescription: 'Showing Transporter Status distribution',
      chartType: 'scorecard',
      layout: 'horizontal',
      hideDimension: true,
      benchmarkDimension: {},
      dimensionDescription: 'Status Count ',
      metricDescription: 'Transporter',
      metric: {
        aggKey: {
          label: 'Transit Performance',
          value: 'delivery_tat'
        },
        aggType: {
          value: 'range',
          label: 'Range'
        },
        metricUnit: {
          key: 'number',
          value: 'number'
        },
        value: [
          {
            key: 'Early',
            to: -1
          },
          {
            key: 'Ontime',
            from: 0,
            to: 1
          },
          {
            key: 'Delay',
            from: 2
          }
        ]
      },
      sortKey: {
        label: 'Values',
        value: 'value_count'
      },
      maxNoOfBars: 30,
      compactNo: false,
      decimalPrecision: '',
      filter: [],
      pageIdList: null
    },
    style: {
      graphScreenRatio: 1.7777777777777777
    },
    order: 5
  }
}
